var messages = {
  title: '展開する'
};
export default messages;